import { jsx } from 'react/jsx-runtime';
import { Badge } from '@sbt-web/ui';
import styles from './index.module.css.js';

const SoldBadge = () => {
    return (jsx(Badge, { classes: [styles.soldBadge], flavor: "small", rounded: true, children: "Venduto" }));
};

export { SoldBadge };
//# sourceMappingURL=index.js.map
